import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { patientId: Number }

  copyPreferencesLink(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const originalText = button.innerHTML
    
    // Construir la URL para la petición JSON usando el patient_id del data attribute
    const patientId = this.patientIdValue
    if (!patientId) {
      this.showError(button, originalText, 'No se pudo identificar al paciente')
      return
    }
    
    const jsonUrl = `/patients/${patientId}/patient_access_tokens/create_for_preferences.json`

    // Deshabilitar el botón mientras se procesa
    button.disabled = true
    button.style.opacity = '0.6'
    button.style.cursor = 'not-allowed'

    fetch(jsonUrl, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }
      return response.json()
    })
    .then(data => {
      if (data.success && data.url) {
        // Copiar al portapapeles
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(data.url).then(() => {
            this.showSuccess(button, originalText)
          }).catch(() => {
            this.fallbackCopy(data.url, button, originalText)
          })
        } else {
          this.fallbackCopy(data.url, button, originalText)
        }
      } else {
        throw new Error(data.errors?.join(', ') || 'Error al generar el link')
      }
    })
    .catch(error => {
      console.error('Error:', error)
      this.showError(button, originalText, error.message)
    })
    .finally(() => {
      // Rehabilitar el botón después de un tiempo
      setTimeout(() => {
        button.disabled = false
        button.style.opacity = '1'
        button.style.cursor = 'pointer'
      }, 2000)
    })
  }

  fallbackCopy(text, button, originalText) {
    // Método fallback para navegadores antiguos
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      const successful = document.execCommand('copy')
      if (successful) {
        this.showSuccess(button, originalText)
      } else {
        this.showError(button, originalText, 'No se pudo copiar al portapapeles')
      }
    } catch (err) {
      this.showError(button, originalText, 'Error al copiar')
    } finally {
      document.body.removeChild(textArea)
    }
  }

  showSuccess(button, originalText) {
    button.innerHTML = '<i class="fas fa-check mr-2"></i>Link copiado!'
    button.style.backgroundColor = '#28a745'
    button.style.borderColor = '#28a745'

    setTimeout(() => {
      button.innerHTML = originalText
      button.style.backgroundColor = '#ff9800'
      button.style.borderColor = '#ff9800'
    }, 2000)
  }

  showError(button, originalText, errorMessage) {
    button.innerHTML = '<i class="fas fa-exclamation-triangle mr-2"></i>Error'
    button.style.backgroundColor = '#dc3545'
    button.style.borderColor = '#dc3545'

    setTimeout(() => {
      button.innerHTML = originalText
      button.style.backgroundColor = '#ff9800'
      button.style.borderColor = '#ff9800'
    }, 2000)

    // Mostrar mensaje de error en la página
    const flashContainer = document.getElementById('flashes') || document.body
    const alertDiv = document.createElement('div')
    alertDiv.className = 'alert alert-danger alert-dismissible fade show'
    alertDiv.style.zIndex = '9999'
    alertDiv.innerHTML = `
      <span>${errorMessage}</span>
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    `
    flashContainer.insertBefore(alertDiv, flashContainer.firstChild)

    setTimeout(() => {
      alertDiv.remove()
    }, 5000)
  }
}

